






































































import { Vue, Component, Watch } from 'vue-property-decorator'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { mapGetters, mapState } from 'vuex'
import ChoixPoste  from '@/views/GestionPortailCandidat/Onglets/ChoixPoste.vue'
import AccesFormulaireInscription from '@/views/GestionPortailCandidat/Onglets/AccesFormulaireInscription.vue'
import AccesResultats  from '@/views/GestionPortailCandidat/Onglets/AccesResultats.vue'
import AccesReclamations  from '@/views/GestionPortailCandidat/Onglets/AccesReclamations.vue'
import AccesOrganisation from '@/views/GestionPortailCandidat/Onglets/AccesOrganisation.vue'
import AccesOrganisationOraux from '@/views/GestionPortailCandidat/Onglets/AccesOrganisationOraux.vue'
import Parametrage from '@/views/GestionPortailCandidat/Onglets/Parametrage.vue'
import Candidats from '@/views/GestionPortailCandidat/Onglets/Candidats.vue'
import NotificationPortail from '@/views/GestionPortailCandidat/Onglets/NotificationPortail.vue'

@Component({
    computed: {
        ...mapGetters('auth', ['authUser', 'can', 'cannot', 'isA', 'isNotA', 'user_session_id']),
        ...mapState('auth', ['user', 'authUser', 'user_session_id'])
    },
    components: {
        'font-awesome-icon': FontAwesomeIcon,
        // AccesInscriptions,
        AccesFormulaireInscription,
        AccesResultats,
        AccesReclamations,
        AccesOrganisation,
        AccesOrganisationOraux,
        Parametrage,
        NotificationPortail,
        ChoixPoste,
        Candidats
    }
})

export default class GestionPortailCandidats extends Vue {
    ongletSelect = 'publications'
    typePublications = 'resultats'

    @Watch('ongletSelect')
    @Watch('typePublications')
    refreshPublications () {
        if (this.ongletSelect === 'publications') {
            // Changement d'onglet on refresh les publications
            this.$store.dispatch('publication/getPublications')
        }
    }

    @Watch('user_session_id')
    refreshInterface () {
        this.load()
    }

    load () {
        this.$store.dispatch('publication/getPublications')
    }

    beforeMount () {
        if (this.$store.getters['auth/user_session_id'] !== null) {
            this.load()
        }
    }
}
